
// Angular
import { BrowserModule,
         DomSanitizer } from '@angular/platform-browser'

import { NgModule,
         Optional,
         SkipSelf } from '@angular/core'
         // ɵ_sanitizeStyle } from '@angular/core'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { HttpClientModule } from '@angular/common/http'

// import { CookieModule } from 'ngx-cookie';

import { ApiService } from './_services/api.service'
import { HttpService } from './_services/http.service'

// import { ActivityService } from './_services/activity.service'
// import { AddressService } from './_services/address.service'
// import { AttachmentService } from './_services/attachment.service'
// import { AuthService } from './_services/auth.service'
// import { RootService } from './_services/root.service'
import { CookieService } from './_services/cookie.service'
// import { ControlService } from './_services/control.service'
// import { ContentfulService } from './_services/contentful.service'
import { ContentService } from './_services/content.service'
// import { EmailService } from './_services/email.service'
// import { EntryService } from './_services/entry.service'
// import { ExplorationService } from './_services/exploration.service'
// import { FeedService } from './_services/feed.service'
// import { FeedbackService } from './_services/feedback.service'
// import { GeonameService } from './_services/geoname.service'
// import { HighlightService } from './_services/highlight.service'
// import { HyperlinkService } from './_services/hyperlink.service'
// import { ItemCollectionService } from './_services/item-collection.service'
// import { IpDetailService } from './_services/ip-detail.service'
// import { ItemService } from './_services/item.service'
import { LazyLoaderService } from './_services/lazy-loader.service'
// import { MapService } from './_services/map.service'
// import { LocationService } from './_services/location.service'
import { KeyboardService } from './_services/keyboard.service'
// import { MainService } from './_services/main.service'
// import { ModalService } from './_services/modal.service'
// import { PageService } from './_services/page.service'
// import { PagerService } from './_services/pager.service'
// import { PointService } from './_services/point.service'
// import { PolicyService } from './_services/policy.service'
// import { QuillService } from './_services/quill.service'
import { RouterService } from './_services/router.service'
// import { SearchService } from './_services/search.service'
// import { SettingService } from './_services/setting.service'
// import { SharedService } from './_services/shared.service'
// import { TitleService } from './_services/title.service'
// import { ToastService } from './_services/toast.service'

import { MessageService } from './_services/message.service'
// import { OrderService } from './_services/order.service'
// import { PaymentService } from './_services/payment.service'
// import { ServiceService } from './_services/service.service'
import { SettingService } from './_services/setting.service'

import { TokenService } from './_services/token.service'
// import { UserService } from './_services/user.service'
// import { PaymentService } from './_services/payment.service'
// import { ServicesService } from './_services/services.service'
import { WindowService } from './_services/window.service'


// // DOMPurify
// import { NgDompurifySanitizer,
//          NgDompurifyModule,
//          SANITIZE_STYLE,
//          DOMPURIFY_CONFIG,
//          DOMPURIFY_HOOKS } from '@tinkoff/ng-dompurify'

// Quill
// import { Quill } from './quill/quill'
// import { QuillClipboard } from './quill/quill-clipboard'
// import { QuillLinkFormat } from './quill/quill-link-format'

// Misc
// import { CookieService as NgxCookieService } from 'ngx-cookie-service'
// import { FadeAnimation } from './_helpers/animations'
// import { MiscHelper } from './_helpers/misc-helper'
import { AppHelper } from './_helpers/app-helper'
// import { OverviewHelper } from './_helpers/overview-helper'
// import { PageHelper } from './_helpers/page-helper'
import { AppStatic } from './_helpers/app-static'
import { LcpHelper } from './_helpers/lcp-helper'

// import { AppValidators } from './_helpers/app-validators'

// import { ToastrModule } from 'ngx-toastr'

import { NgxWebstorageModule } from 'ngx-webstorage'
import { UserService } from './_services/user.service'
import { AuthService } from './_services/auth.service'
import { PageHelper } from './_helpers/page-helper'
import { TypableService } from './_services/typable.service'

// import { SocialLoginModule } from '../social-login/sociallogin.module'

// import { ngResizeObserverProviders,
//          NgResizeObserver } from 'ng-resize-observer'

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,

    // CookieModule.withOptions(),

    //NgxWebstorageModule.forRoot({ prefix: 'custom', separator: '.', caseSensitive:true })
    // The forRoot method allows to configure the prefix, the separator and the caseSensitive option used by the library
    // Default values:
    // prefix: "ngx-webstorage"
    // separator: "|"
    // caseSensitive: false

    NgxWebstorageModule.forRoot(),

    // ToastrModule.forRoot(),
  ],
  declarations: [
  ],
  providers: [
    ApiService,
    HttpService,

    // ActivityService,
    // AddressService,
    // AttachmentService,
    AuthService,
    CookieService,
    // ControlService,
    ContentService,
    // ContentfulService,
    // EmailService,
    // EntryService,
    // ExplorationService,
    // FeedService,
    // FeedbackService,
    // GeonameService,
    // HighlightService,
    // HyperlinkService,
    // ItemCollectionService,
    // IpDetailService,
    // ItemService,
    KeyboardService,
    LazyLoaderService,
    // MainService,
    // MapService,
    // ModalService,
    // NgxWebstorageModule,
    // ngResizeObserverProviders,
    // NgResizeObserver,

    // LocationService,
    // PageService,
    // PagerService,
    // PointService,
    // PolicyService,
    // QuillService,
    // RootService,
    RouterService,
    // SearchService,
    // SettingService,
    // SharedService,

    // SocialLoginModule,

    // ToastService,
    // TitleService,
    MessageService,
    // OrderService,

    // PaymentService,
    // ServiceService,
    SettingService,
    WindowService,

    TokenService,
    TypableService,
    UserService,

    // MiscHelper,
    AppHelper,
    // OverviewHelper,
    PageHelper,
    AppStatic,
    LcpHelper,
    // AppValidators,

    // { provide: DomSanitizer,
    //   useClass: NgDompurifySanitizer },

    // { provide: DOMPURIFY_CONFIG,
    //   useValue: { FORBID_ATTR: ['id', 'style'] } },

    // { provide: DOMPURIFY_HOOKS,
    //   useValue: [{
    //     name: 'beforeSanitizeAttributes',
    //     hook: (node: Element) => {
    //       node.removeAttribute('id');
    //     },
    //   }] },

    // { provide: SANITIZE_STYLE,
    //   useValue: ɵ_sanitizeStyle },
  ],
  exports: [
  ]
})

export class CoreModule {
  constructor (@Optional() @SkipSelf() parentModule: CoreModule) {
    if (!parentModule) return
    throw new Error('CoreModule is already loaded. Import it in the AppModule only')
  }
}
